"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetType = void 0;
var FacetType;
(function (FacetType) {
    FacetType["Numeric"] = "numeric";
    FacetType["MultiSelect"] = "multi-select";
    FacetType["String"] = "string";
    FacetType["Select"] = "select";
    FacetType["Checkbox"] = "checkbox";
    FacetType["Duration"] = "duration";
    FacetType["Quantity"] = "quantity";
    FacetType["Boolean"] = "boolean";
})(FacetType = exports.FacetType || (exports.FacetType = {}));
//# sourceMappingURL=facetType.js.map